module.exports = __webpack_public_path__ + "img/pic-07.6c117832.jpg";